var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.1392 29V20.9H23.5983L24 17.3H21.1392V15.5468C21.1392 14.6198 21.1628 13.7 22.4582 13.7H23.7702V11.126C23.7702 11.0873 22.6432 11 21.5031 11C19.122 11 17.6311 12.4913 17.6311 15.23V17.3H15V20.9H17.6311V29H21.1392Z"}));
}

Facebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"gray"};

module.exports = Facebook;

Facebook.default = Facebook;
